
export const state = {
   promoterDrawer: false,
   flowPermission: [],
   approverDrawer: false,
   approverConfig:{
    nodeUserList: []
   },
   copyerDrawer: false,
   copyerConfig:{},
   conditionDrawer: false,
   conditionsConfig:{
       conditionNodes: [],
   }
}
export const mutations = {
  updatePromoter(state,promoterDrawer){
    state.promoterDrawer = promoterDrawer
  },
  updateFlowPermission(state,flowPermission){
      state.flowPermission = flowPermission
  },
  updateApprover(state,approverDrawer){
      state.approverDrawer = approverDrawer
  },
  updateApproverConfig(state,approverConfig){
      state.approverConfig = approverConfig
  },
  updateCopyer(state,copyerDrawer){
      state.copyerDrawer = copyerDrawer
  },
  updateCopyerConfig(state,copyerConfig){
      state.copyerConfig = copyerConfig
  },
  updateCondition(state,conditionDrawer){
      state.conditionDrawer = conditionDrawer
  },
  updateConditionsConfig(state,conditionsConfig){
      state.conditionsConfig = conditionsConfig
  },
}
export const getters = {
  promoterDrawer: state => state.promoterDrawer,
  flowPermission: state => state.flowPermission,
  approverDrawer: state => state.approverDrawer,
  approverConfig: state => state.approverConfig,
  copyerDrawer: state => state.copyerDrawer,
  copyerConfig: state => state.copyerConfig,
  conditionDrawer: state => state.conditionDrawer,
  conditionsConfig: state => state.conditionsConfig
}
export const actions = {
}
